'use client';

import { DeliveryType } from '@ahm/api-wrappers-core';
import { rem } from '@mantine/core';
import { openContextModal } from '@mantine/modals';
import { useMemo } from 'react';
import InfoTooltip from '@/components/info-tooltip';
import { ModalName } from '@/components/modals';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { getServiceType } from '@/lib/utils';
import { useLocaleSuffix, usePathname } from '@/navigation';

export default function BookingServiceInfoTooltip(innerProps) {
  const isMobile = useIsMobile();

  const localeSuffix = useLocaleSuffix();
  const pathname = usePathname();
  const { isTruckService } = useMemo(
    () => getServiceType(pathname),
    [pathname]
  );
  if (!innerProps.service) {
    return null;
  }

  if (
    isTruckService ||
    innerProps.service.delivery_type === DeliveryType.Truck
  ) {
    return (
      <InfoTooltip
        label={innerProps.service[`name_${localeSuffix}`]}
        onClick={(event) => {
          event.stopPropagation();
          openContextModal({
            modal: ModalName.TruckServiceDetails,
            innerProps,
            h: '100%',
            closeOnClickOutside: false,
            closeOnEscape: false,
            withCloseButton: true,
            centered: true,
            fullScreen: isMobile,
            w: '100%',
            zIndex: 1001,
            title: 'Chi tiết xe',

            styles: {
              root: { zIndex: 1001 },
              inner: {
                padding: 0,
              },
              title: {
                textAlign: 'center',
                width: '100%',
                fontSize: 18,
                fontWeight: 700,
              },
              header: {
                padding: 0,
                minHeight: 44,
              },
              close: {
                outline: 'none',
                position: 'absolute',
                ...(isMobile
                  ? {
                      left: rem(16),
                    }
                  : {
                      right: rem(16),
                    }),
              },

              body: {
                position: 'relative',
                padding: 0,
                backgroundColor: 'var(--mantine-color-neutral-0)',
              },
            },
          });
        }}
      />
    );
  }

  return (
    <InfoTooltip
      label={innerProps.service[`name_${localeSuffix}`]}
      onClick={(event) => {
        event.stopPropagation();
        openContextModal({
          modal: ModalName.ServiceDetails,
          innerProps,
          h: 'fit-content',
          closeOnClickOutside: false,
          closeOnEscape: false,
          withCloseButton: false,
          centered: true,
          // scrollAreaComponent: ScrollArea.Autosize,
          maw: rem(440),
          w: '100%',
          zIndex: 1001,
          styles: {
            root: { zIndex: 1001 },
            inner: {
              padding: 0,
              overflow: 'hidden',
            },
            content: {
              backgroundColor: 'white',
              overflow: 'hidden',
              margin: rem(16),
              maxWidth: `calc(100% - ${rem(32)})`,
            },
            body: {
              position: 'relative',
              padding: rem(16),
              paddingTop: rem(48),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'var(--stack-align, stretch)',
              justifyContent: 'var(--stack-justify, flex-start)',
              maxHeight:
                'var(--modal-content-max-height, calc(100dvh - var(--modal-y-offset) * 2))',
            },
          },
        });
      }}
    />
  );
}
